import { foldersService, type LibraryFolder } from "@/services/foldersService";

/**
 * From Google Drive folder import, `folderPath` is `rootName` or `rootName/sub/...`.
 * Returns the Drive root folder name for mirroring in the Library, or null if absent.
 */
export function getGoogleDriveImportRootFolderName(
  files: Array<{ folderPath?: string }>
): string | null {
  for (const file of files) {
    const raw = file.folderPath?.trim();
    if (!raw) continue;
    const first = raw.split("/")[0]?.trim();
    if (first) return first;
  }
  return null;
}

/**
 * Idempotent: find a folder by exact name under `parentId`, or create it.
 * `workspaceId` matches `foldersService.createFolder`: null/empty = personal row; string = workspace.
 */
export async function ensureLibraryFolderByName(
  name: string,
  parentId: string | null,
  workspaceId: string | null,
  siblings: LibraryFolder[]
): Promise<string> {
  const trimmed = name.trim();
  if (!trimmed) {
    throw new Error("Folder name is required");
  }
  const parent = parentId ?? null;
  const existing = siblings.find(
    (f) => f.name === trimmed && (f.parentId ?? null) === parent
  );
  if (existing) return existing.id;

  const created = await foldersService.createFolder(
    { name: trimmed, parentId: parent },
    workspaceId
  );
  return created.id;
}
